import { SET_AGENT_DETAILS, INITIAL_STATE, SET_AGENTS_LIST } from '../actions/agentActions'

const initialState = {
  agent: {
    id: null,
    avatar: null,
    avatarFile: null,
    name: '',
    description: '',
    icon: null,
    model: {},
    agentType: '',
    scopeId: null,
    instructions: '',
    skills: [],
    plugins: [],
    source: 'Ali'
  },
  agentsList: []
}

export default function agentReducer(state = initialState, action) {
  switch (action.type) {
    case INITIAL_STATE: {
      return {
        agent: {
          ...initialState.agent
        },
        agentsList: []
      }
    }
    case SET_AGENT_DETAILS: {
      const payload = { ...action.payload }
      // Filter out File objects to prevent Redux mutations
      if (payload.avatar instanceof File) {
        payload.avatar = payload.avatar.icon || null
      }
      return {
        ...state,
        agent: payload
      }
    }
    case SET_AGENTS_LIST: {
      return {
        ...state,
        agentsList: action.payload || []
      }
    }
    default:
      return {
        ...state,
        agentsList: state.agentsList || []
      }
  }
}
